/* E-shop overlaye (vyhledávání, košík, hamburger menu, panel filtrů) se přisazují
   ke spodní hraně lišty menu. Ta se v čase mění — klidový bar má 60px (mobil),
   90px (tablet) nebo 69px (mega desktop), sbalený scroll bar 44px — a drawer je
   mimo scope headeru, takže scoped --us-header-height na něj nedosáhne.
   Měříme proto živou spodní hranu baru ve viewportu (ne jen jeho výšku): když je
   bar odscrollovaný pryč, vyjde 0 a overlay sedí na hraně okna bez mezery. */
window.alignEshopSidebar = function (sidebar) {
	if ( !sidebar ) return;
	if ( !sidebar.classList.contains('sidebar--eshop') && !sidebar.classList.contains('mobile-nav--eshop') ) return;
	const bar = document.querySelector('main-header .main-header-container');
	if ( !bar ) return;
	const offset = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
	sidebar.style.top = `${offset}px`;
	sidebar.style.height = `calc(var(--window-height) - ${offset}px)`;
};

if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();

			this._headerMobileHeight = 75;
			this._headerDesktopHeight = 90;

			this._mobileBreakpoint = 1024;
		}

		mount(){
			/* -- > DRAWERS < -- */

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Sticky header

			// TODO: this will be nice as some plugin out of the box solution
			if (this.hasAttribute('data-sticky-header')) {
				window.lst = window.scrollY;
				window.lhp = 0;

				if (this.classList.contains('site-header--eshop')) {

					// E-shop header: stay visible at all times while scrolling
					// (issue 1 — no hide-on-scroll-down). Near the top show the
					// full "big" menu; once scrolled past a generous threshold
					// pin a compact bar (logo + burger). The hysteresis between
					// EXPAND_AT and COLLAPSE_AT makes the big menu reappear
					// reliably as you approach the top (issue 2).
					const PIN_AT = 5;        // px — pin the bar (fixed) once scrolled
					const COLLAPSE_AT = 180; // px — collapse big menu → compact bar
					const EXPAND_AT = 100;   // px — restore big menu on the way up

					// The e-shop bar never hides, so set the transform once here instead
					// of on every scroll tick, and cache the container to avoid a
					// per-tick DOM query.
					const container = this.querySelector('.main-header-container');
					if (container) container.style.transform = 'translateY(0)';

					let isPinned = null;
					let isCollapsed = null;

					this.SCROLL_StickyHelper = () => {
						const st = window.scrollY;
						if (st < 0) return;

						// Always-visible pinned bar (never translated out of view).
						const pin = st > PIN_AT;
						if (pin !== isPinned) {
							this.classList.toggle('is-pinned', pin);
							isPinned = pin;
						}

						// Hysteresis between EXPAND_AT and COLLAPSE_AT; touch the DOM
						// only when the collapsed state actually flips.
						if (st > COLLAPSE_AT && isCollapsed !== true) {
							this.classList.add('stick-show');
							isCollapsed = true;
						} else if (st < EXPAND_AT && isCollapsed !== false) {
							this.classList.remove('stick-show');
							isCollapsed = false;
						}
					};

					window.addEventListener('scroll', this.SCROLL_StickyHelper, { passive: true });
					// Sync state on load (e.g. refresh while scrolled mid-page).
					this.SCROLL_StickyHelper();

				} else {

					this.SCROLL_StickyHelper = () => {
						var st = window.scrollY;

						if (st < 0 || Math.abs(lst - st) <= 5) {
							return;
						}

						const hasClass = this.classList.contains('stick-show');

						if (st == 0 && hasClass) {
							this.classList.remove('stick-show');
						}

						const windowW = window.innerWidth;

						if (st > window.lhp && st > (windowW >= this._mobileBreakpoint ? this._headerDesktopHeight : this._headerMobileHeight)) {
							if (st == 0 && hasClass) {
								this.querySelector('.main-header-container').style.transform = 'translateY(-100%)';
								this.classList.remove('stick-show');
							} else if (st <= window.lst && !hasClass) {
								window.lhp = this.offsetTop;
								this.querySelector('.main-header-container').style.transform = 'translateY(0)';
								this.classList.add('stick-show')
							} else if (st > window.lst && hasClass) {
								this.querySelector('.main-header-container').style.transform = 'translateY(-100%)';
								this.classList.remove('stick-show');
							}
						}
						window.lst = st;
					}

					window.addEventListener('scroll', this.SCROLL_StickyHelper, { passive: true });

				}

			}

			// drawer connections

			// E-shop overlay (search/košík/hamburger menu) napojit na aktuální
			// spodní hranu baru — sdílený helper nahoře v tomto souboru.
			const alignEshopSidebar = window.alignEshopSidebar;

			// Re-align an open e-shop overlay when the viewport changes: the bar
			// height differs between the big (69px) and collapsed (60px) states, and
			// crossing the 1340px breakpoint hands positioning back to CSS.
			// Přepočet je omezený na jeden frame (rAF): scroll se pálí často a měření
			// baru je layout read — bez toho by při každém pixelu scrollu vznikal
			// zbytečný reflow.
			let realignQueued = false;
			const realignOpenEshopSidebars = () => {
				if ( realignQueued ) return;
				realignQueued = true;
				requestAnimationFrame(() => {
					realignQueued = false;
					document.querySelectorAll('.sidebar--opened.sidebar--eshop, .sidebar--opened.mobile-nav--eshop')
						.forEach(alignEshopSidebar);
				});
			};
			window.addEventListener('resize', realignOpenEshopSidebars, { passive: true });
			// Scroll: bar přepíná mezi klidovou a sbalenou výškou i s otevřeným
			// overlayem, takže offset je potřeba přepočítat i tady.
			window.addEventListener('scroll', realignOpenEshopSidebars, { passive: true });

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						alignEshopSidebar(elmSidebar);
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							alignEshopSidebar(elmSidebar);
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			});
			if ( this.classList.contains('site-header--alignment-left') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}

			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});

			document.querySelectorAll('main-header [data-js-close]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'false');
						elmSidebar.hide(true);
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'false');
							elmSidebar.hide(true);
						}
					})
				}
			});

			if ( this.classList.contains('site-header--alignment-left') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}

			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// submenu masonry
            let submenusMacy = [];
			document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach(elm=>{
				if ( Macy ) {
					const submenuMacy = new Macy({
						container: elm,
						columns: parseInt(elm.getAttribute('data-columns')),
						margin: 30
					});
					setTimeout(()=>{
						submenuMacy.reInit();
					}, 100);

                    submenusMacy.push(submenuMacy);
				}
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS);
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {

				this.querySelector('search-form').addEventListener('click', e=>{
					e.preventDefault();
					window.location.href = KROWN.settings.routes.search_url;
				});

			}

			// touch menu helpers

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}

			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				const menuLink = elm.querySelector('.menu-link');
				if (!menuLink) return;

				const handleInteraction = (e) => {
					if (menuLink.getAttribute('href') && (!menuLink.classList.contains('parent-level-1') && !menuLink.classList.contains('parent-level-2'))) return;

					e.preventDefault();
					e.stopPropagation();
					elm.classList.toggle('focus');
					closeTouchSubmenus(elm, elm.closest('.has-submenu'));
					babyMenuTouch = true;
				};

				menuLink.addEventListener('touchstart', handleInteraction, { passive: false });
				menuLink.addEventListener('click', handleInteraction);
			});

			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if (!elm.classList.contains('mega-link')) {
					const menuLink = elm.querySelector('.menu-link');
					if (!menuLink) return;

					const handleInteraction = (e) => {
						if (menuLink.getAttribute('href') && (!menuLink.classList.contains('parent-level-1') && !menuLink.classList.contains('parent-level-2'))) return;

						if (!babyMenuTouch) {
							e.preventDefault();
							e.stopPropagation();
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
						}
						babyMenuTouch = false;
					};

					menuLink.addEventListener('touchstart', handleInteraction, { passive: false });
					menuLink.addEventListener('click', handleInteraction);
				}
			});

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'true');
						}
					}
				});

				if ( elm.querySelector('.submenu-holder > li:last-child a') ) {
					elm.querySelector('.submenu-holder > li:last-child a').addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl => {

				const elm = childEl.parentNode;

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							elm.setAttribute('aria-expanded', 'true');
						} else {
							elm.classList.remove('focus');
							elm.setAttribute('aria-expanded', 'false');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});
		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}

  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			const jsClose = this.querySelector('[data-js-close]')

			if (jsClose) {
				jsClose.addEventListener('click', function (e) {
					e.preventDefault();
					this.hide();
				});
			}
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/*
			* generic hide/show functions
		*/

		show(){

			// Panel filtrů se otevírá inline onclickem z facets snippetů, tedy mimo
			// [data-js-sidebar-handle] v MainHeader — zarovnání pod lištu proto dělá
			// samotné show(), ať platí pro všechny e-shop overlaye bez ohledu na to,
			// co je otevřelo.
			window.alignEshopSidebar?.(this);

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}
			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				// window.inertElems.forEach(elm=>{
				// 	elm.setAttribute('inert', '');
				// })
			}, 15);

		}

		hide (hideall = false) {
			this._opened = false;
			this.classList.remove('sidebar--opened');

			// Check if there are other open sidebars before removing body classes
			const otherOpenSidebars = document.querySelectorAll('sidebar-drawer.sidebar--opened');

			// If hideall is true, hide all other open sidebars
			if (hideall) {
				otherOpenSidebars.forEach(sidebar => {
					if (sidebar !== this) {
						sidebar.hide(false, true);
					}
				});
			}

			// Remove body classes if no other sidebars or hideall is true
			if (otherOpenSidebars.length === 0 || hideall) {
				document.body.classList.remove('sidebar-opened');
				document.body.classList.remove('sidebar-opened--left');
				document.body.classList.remove('sidebar-opened--right');
			}

			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {

	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			this.querySelectorAll('.has-submenu > .menu-link').forEach(elm => {
				elm.addEventListener('click', e=>{
					if (elm.getAttribute('href') && (!elm.classList.contains('parent-level-1') && !elm.classList.contains('parent-level-2'))) return;

					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						document.body.classList.add('opened-first-submenu');
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeNav();
					this._resizeContainer();
				})
			});

			this.querySelectorAll('.has-babymenu .menu-link').forEach(elm => {
				elm.addEventListener('click', e=>{
					if (elm.getAttribute('href') && (!elm.classList.contains('parent-level-1') && !elm.classList.contains('parent-level-2'))) return;

					e.preventDefault();
					if ( ! this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = true;
						document.body.classList.add('opened-second-submenu');
						this.classList.add('opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
					}
					e.target.closest('li').classList.add('opened');
					this._resizeNav();
					this._resizeContainer();
				})
			});

			document.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedSecondSubmenu ) {
						this._openedSecondSubmenu = false;
						this.classList.remove('opened-second-submenu');
						document.body.classList.remove('opened-second-submenu');
						$('.menu-item-li--level-1').each(function() { $(this).removeClass('opened'); });
						this._resizeContainer();
					} else if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						document.body.classList.remove('opened-first-submenu');
						$('.menu-item-li--level-0').each(function() { $(this).removeClass('opened'); });
						this._resizeContainer(true);
					}
					this._resizeNav();
					this.closest('sidebar-drawer').scrollTo({top: 0});
					e.preventDefault();
				})
			});

		}

		_resizeNav() {
			const $mobileNav = $('mobile-navigation');
			const $sidebarContainer = $mobileNav.find('.site-nav-container');
			const footerHeight = $mobileNav.find('.site-menu-sidebar-footer').outerHeight() || 0

			// Second level must be tested first: opening it leaves _openedFirstSubmenu
			// true as well, so the original order never reached the level-2 branch.
			var selector = 'nav > .link-list';
			if (this._openedSecondSubmenu) {
				selector = '.opened .link-list.level-2';
			} else if (this._openedFirstSubmenu) {
				selector = '.opened .link-list.level-1';
			}

			const height = $sidebarContainer.find(selector).outerHeight() || 0;

			// E-shop panel: the drill-down lists are position:absolute (they slide),
			// so <nav> keeps the height of the FIRST level and anything after it in
			// the flow (the search / cart / account row) would be overlapped by a
			// longer sub-list. Give <nav> the height of the list that is actually
			// visible — the utility row then simply follows it, whatever the level.
			// Brand menu keeps the original behaviour (height on the container,
			// which also reserves room for its social/contact footer).
			if (this.closest('.mobile-nav--eshop')) {
				$sidebarContainer.find('> nav').css('height', `${height}px`);
				$sidebarContainer.css('height', '');
			} else {
				$sidebarContainer.css('height', `${height + footerHeight}px`);
			}
		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.opened .submenu').scrollHeight}px`;
				}
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

// Handle dynamic menu images
$(document).ready(function ($) {
	$('[data-image-show]').each(function () {
		const $container = $(this);
		const $imageTarget = $container.find('[data-image-show-target]');
		if (!$imageTarget.length) return;

		const $imageParent = $imageTarget.parent();
		const $triggers = $container.find('[data-img]');
		let currentImage = $imageTarget.attr('src');

		$triggers.on('mouseenter', function () {
			const newImage = $(this).data('img');
			if (!newImage || newImage === currentImage) return;

			$imageParent.removeClass('lazyloaded hidden');
			$imageTarget.attr('src', newImage);
			currentImage = newImage;
		});
	});
});

$(document).ready(function () {

	const menu = $('[data-menu]');
	const popperInstances = new Map();
	let activePopperEl = null;

	// Common popper modifiers
	const getPopperModifiers = (enableEvents = false) => ([
		{
			name: 'offset',
			options: {
				offset: [0, 0],
			},
		},
		{
			name: 'eventListeners',
			enabled: enableEvents
		}
	]);

	// Create popper instances
	menu.find('[data-menu-item-poptarget]').each(function() {
		const $this = $(this);
		const target = $this.attr('data-menu-item-poptarget');
		const $poptarget = $('[data-menu-item-popthis="' + target + '"]');
		const isActive = $poptarget.attr('data-menu-item-active') !== '-1';
		const initPopper = $this.attr('data-init-popper') === 'true';

		if ($poptarget.length) {
			if (initPopper) {
				const popper = Popper.createPopper(this, $poptarget[0], {
					placement: 'right-start',
					modifiers: getPopperModifiers(false),
				});

				popperInstances.set(target, {
					popper,
					$trigger: $this,
					$target: $poptarget,
					isActive
				});

				if (isActive) {
					activePopperEl = target;
					$poptarget.show();
				} else {
					$poptarget.hide();
				}
			} else {
				popperInstances.set(target, $this);
				$this.$popperTarget = $poptarget;

				if (isActive) {
					activePopperEl = target;
					$poptarget.show();
				} else {
					$poptarget.hide();
				}
			}
		}
	});

	// Handle mouseenter and mouseover
	menu.find('[data-menu-item]').on('mouseenter mouseover', function () {
		const $this = $(this);
		const target = $this.attr('data-menu-item-poptarget');
		const initPopper = $this.attr('data-init-popper') === 'true';

		// Hide all poppers except active one
		popperInstances.forEach(function (instance, key) {
			if (key !== target) {
				if (initPopper) {
					instance.$target.hide();
					instance.popper.setOptions({
						modifiers: getPopperModifiers(false)
					});
				} else {
					instance.$popperTarget.hide();
				}
			}
		});

		// Show current popper if it exists
		if (target && popperInstances.has(target)) {
			const instance = popperInstances.get(target);
			if (initPopper) {
				instance.$target.show();
				instance.popper.setOptions({
					modifiers: getPopperModifiers(true)
				});
				instance.popper.update();
			} else {
				instance.$popperTarget.show();
			}
		}
	});

	// Handle mouseleave and mouseout
	menu.find('[data-menu-item]').on('mouseleave mouseout', function (event) {
		const $this = $(this);
		const $related = $(event.relatedTarget);
		const isLeavingToSubmenu = $related.closest('[data-menu-item-popthis]').length > 0;
		const initPopper = $this.attr('data-init-popper') === 'true';

		if (!isLeavingToSubmenu) {
			popperInstances.forEach(function (instance, key) {
				if (key !== activePopperEl) {
					if (initPopper) {
						instance.$target.hide();
					} else {
						instance.$popperTarget.hide();
					}
				} else if (instance.isActive) {
					if (initPopper) {
						instance.$target.show();
						instance.popper.update();
					} else {
						instance.$popperTarget.show();
					}
				}
				if (initPopper) {
					instance.popper.setOptions({
						modifiers: getPopperModifiers(false)
					});
				}
			});
		}
	});

	// Cleanup on page unload
	$(window).on('unload', function() {
		popperInstances.forEach(function (instance) {
			if (instance.popper) {
				instance.popper.destroy();
			}
		});
		popperInstances.clear();
	});
});
